var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "dd",
      { staticClass: "zipcode", class: _vm.klass },
      [
        _vm.validate.$error
          ? [
              _c("span", { staticClass: "errNote" }, [
                _vm._v("郵便番号（半角数字7桁）を入力してください。"),
              ]),
            ]
          : _vm._e(),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.validate.$model,
              expression: "validate.$model",
            },
          ],
          staticClass: "regular",
          attrs: {
            type: "text",
            id: "js-input-zip",
            maxlength: "7",
            placeholder: "1000001",
          },
          domProps: { value: _vm.validate.$model },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.validate, "$model", $event.target.value)
              },
              _vm.toHalfWidth,
            ],
          },
        }),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "span",
      { staticClass: "annotation", staticStyle: { "margin-top": "6px" } },
      [_vm._v("郵便番号を入力すると、住所の一部が自動的に入力されます。")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }